// Expression of Ideas reference sheet — quick-lookup lists for this domain,
// as opposed to the instructional walkthroughs in the Reading and Writing
// domain guide. Keep entries short: a rule or list, not a lesson. Paragraphs
// are plain strings or structured blocks { type: 'list', ... }.

export const documentTitle = 'Expression of Ideas Reference';
export const documentSlug = 'expression-of-ideas-reference';

export const parts = [
  {
    id: 'expression-ideas-reference-full',
    title: null,
    sections: [
      {
        id: 'eir-transition-categories',
        heading: 'Transition Word Categories',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Addition: furthermore, moreover, in addition',
              'Contrast: however, nevertheless, yet, conversely',
              'Cause and effect: therefore, consequently, as a result, thus',
              'Example: for instance, specifically, namely',
              'Concession: admittedly, granted, of course',
              'Sequence: subsequently, meanwhile, afterward',
            ],
          },
        ],
      },
      {
        id: 'eir-rhetorical-synthesis-checklist',
        heading: 'Rhetorical Synthesis Checklist',
        paragraphs: [
          'Restate the stated goal as a short checklist before reading the choices, and test every choice only against that checklist. A choice that\'s accurate but doesn\'t accomplish the specific stated goal is the most common wrong-answer trap.',
        ],
      },
    ],
  },
];
